var Modal = require("components/utility/AltModal");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var LoadingButton = require("components/utility/LoadingButton");
var SchoolSearch = require("components/org/roster/SchoolSearch");
var CurrentUser = require("lib/account/CurrentUser");
var HelpSectionLink = require("components/utility/HelpSectionLink");

require("org/roster/school_info_modal.scss");

class SchoolInfoModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			addedSchool: false, selectedSchool: null, loading: false,
			showManualFields: false, manualName: "", manualZIP: ""
		};
	}

	selectSchool(selectedSchool) {
		this.setState({ selectedSchool: selectedSchool });
	}

	onSubmit(e) {
		$wr.nope(e)

		this.refs.errors.reset();
		var errors = [];

		if (this.state.showManualFields) {
			var zip = this.state.manualZIP.trim();
			var name = this.state.manualName.trim();
			var schoolData = { name: name, zip: zip, pending: false, demographic_bucket: "non-nces" };

			if (name.length == 0) {
				errors.push("Please enter your school's name");
			}
			if (zip.length == 0) {
				errors.push("Please enter your ZIP code (or country if non-US)");
			}
		} else {
			var selectedSchool = this.state.selectedSchool;
			if (!(selectedSchool && selectedSchool.value)) {
				errors.push("Please select a school.")
			} else {
				var searchData = selectedSchool.value;
				var districtName = searchData.district ? searchData.district.name : "No District";
				var schoolData = { pending: false, name: searchData.name, zip: searchData.zip,
					district: districtName, canonical_id: searchData.id,
					demographic_bucket: searchData.demographic_bucket };

			}
		}

		if (errors.length == 0) {
			if (this.props.altSubmit) {
				this.props.altSubmit(schoolData);
				this.refs.modal.hide();
				return;
			}

			var adminID = CurrentUser.get().id;
			CurrentUser.api().patchAdmin(adminID, { admin: { school: schoolData } }, $wr.apiHandler(function(response) {
				this.setState({ addedSchool: true }, function() {
					this.refs.modal.hide();
				}.bind(this));

				window.wrNotifications.triggerDropDownNotification({
					title: "Updated!", text: "Thank you for adding your school information", icon: "star" });
				CurrentUser.fetchCurrentUserData(function() {
					if (this.props.updateSchoolInfo) {
						this.props.updateSchoolInfo();
					}
					$(window.document).trigger("onboarding-trigger-select-school")
				}.bind(this));
			}.bind(this)));
		} else {
			this.refs.errors.setErrors(errors);
		}
	}

	toggleManualFields(e) {
		$wr.nope(e)
		this.refs.errors.reset();
		this.setState({ showManualFields: !this.state.showManualFields });
	}

	renderManualFields() {
		return (
			<div>
				<div className="row">
					<div className="col-sm-8">
						<input className="form-control" placeholder="School" id="schoolName"
							onChange={ (e) => { this.setState({ manualName: e.target.value }) } } />
					</div>
					<div className="col-sm-4">
						<input className="form-control" placeholder="ZIP or Country" id="schoolZIP"
							onChange={ (e) => { this.setState({ manualZIP: e.target.value }) } } />
					</div>
				</div>
				<p className="toggleView">
					<a href="#" onClick={ this.toggleManualFields }>Back to search.</a>
				</p>
			</div>
		);
	}

	renderSchoolSearch() {
		return (
			<div>
				<p className="toggleView">
					<a href="#" onClick={ this.toggleManualFields }>Your school not listed?</a>
				</p>
				<SchoolSearch ref="search" onSelect={ this.selectSchool }
					selectedSchool={ this.state.selectedSchool }
					toggleManual={ this.toggleManualFields } />
			</div>
		);
	}

	render() {
		var toggleView = this.state.showManualFields ? this.renderManualFields() : this.renderSchoolSearch();

		var saveButton = (
			<LoadingButton text="Save" className="btn buttonPrimary saveBtn"
				loading={ this.state.loading } />
		);

		return (
			<Modal className="schoolInfoModal" preventHide={ !this.props.allowHide && !this.state.addedSchool }
				onHide={ this.props.onClose }
				ref="modal" headerText="Select School" modalOrder={ 2 }>

				<div className="innerWrap">
					<div className="clearfix">
						<p className="aboveFieldsText">
							Select your school to see how your students compare
							to other students at similar schools.
						</p>
						<form onSubmit={ this.onSubmit } className="reverseLabels" >
							<ErrorDisplay ref="errors" />
							{ toggleView }
							{ saveButton }
							
							<img src={ require("misc/school-and-owls.png") } className="bannerImg" />
						</form>
					</div>
				</div>
			</Modal>
		);
	}

	componentDidMount() {
		this.refs.modal.show();
	}
};

SchoolInfoModal.propTypes = StrictPropTypes({
	altSubmit: PropTypes.func, // Alt submit behavior
	updateSchoolInfo: PropTypes.func,
	afterSubmit: PropTypes.func,
	allowHide: PropTypes.bool,
	onClose: PropTypes.func
});

module.exports = SchoolInfoModal;


// WEBPACK FOOTER //
// ./modules/components/org/roster/SchoolInfoModal.js